module.exports = __webpack_public_path__ + "fonts/IRANYekanWebMedium.7aef43b.woff";